import styled from 'styled-components'

export const CropContainer = styled.div`
  position: relative;
  width: 100%;
  height: 400px;
  background-color: #f5f5f5;
`

export const Controls = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
`

export const SliderControl = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  label {
    font-size: 14px;
    font-weight: 500;
    color: #333;
  }

  input[type='range'] {
    width: 100%;
    height: 6px;
    background: #ddd;
    outline: none;
    border-radius: 3px;

    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 18px;
      height: 18px;
      background: #007bff;
      cursor: pointer;
      border-radius: 50%;
    }

    &::-moz-range-thumb {
      width: 18px;
      height: 18px;
      background: #007bff;
      cursor: pointer;
      border-radius: 50%;
      border: none;
    }
  }
`
